unit unit_LieferscheinUnterschrift;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, Vcl.StdCtrls, WEBLib.StdCtrls,
  VCL.TMSFNCCustomControl, VCL.TMSFNCSignatureCapture, Vcl.Controls,
  WEBLib.ExtCtrls, WEBLib.SignatureCapture;

type
  TLieferscheinUnterschrift = class(TForm)
    sourceUnterschriften: TDataSource;
    dsUnterschriften: TXDataWebDataSet;
    dsUnterschriftenNummerkomplett: TStringField;
    dsUnterschriftenDatum: TDateTimeField;
    dsUnterschriftenUnterschriftKunde: TBlobField;
    dsUnterschriftenUnterschriftKundeText: TStringField;
    panelUnterschreiben: TPanel;
    WebEdit1: TEdit;
    WebLabel1: TLabel;
    dsUnterschriftenNachnameKunde: TStringField;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    btnUSpeichern: TButton;
    btnUAbbrechen: TButton;
    SigKunde: TSignatureCapture;
    procedure btnUAbbrechenClick(Sender: TObject);
    procedure btnUSpeichernClick(Sender: TObject);
    procedure dsUnterschriftenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure dsUnterschriftenAfterPost(DataSet: TDataSet);
    procedure WebFormShow(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    UMerkerLieferschein:string;
  protected procedure LoadDFMValues; override; end;

var
  LieferscheinUnterschrift: TLieferscheinUnterschrift;

implementation
  uses unit1, unit2;
{$R *.dfm}


procedure TLieferscheinUnterschrift.btnUAbbrechenClick(Sender: TObject);
begin
  self.Close;
end;

procedure TLieferscheinUnterschrift.btnUSpeichernClick(Sender: TObject);
begin
  dsunterschriften.Append;
  dsUnterschriftenNummerkomplett.AsString:=UMerkerLieferschein;
  dsUnterschriftenDatum.AsDateTime:=date+time;
  dsUnterschriftenUnterschriftKundeText.AsString:=sigkunde.GetAsBase64Image;
  dsUnterschriftenNachnameKunde.AsString:=WebEdit1.Text;
  dsUnterschriften.Post;
end;

procedure TLieferscheinUnterschrift.dsUnterschriftenAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
begin
  self.Close;
end;

procedure TLieferscheinUnterschrift.dsUnterschriftenAfterPost(
  DataSet: TDataSet);
begin
  if LizenzOK then
  begin
    dsUnterschriften.ApplyUpdates;
  end
  else
  begin
    showmessage('Für das Speichern von Daten sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
  end;
end;

procedure TLieferscheinUnterschrift.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Unterschrift Lieferschein '+UMerkerLieferschein+'</h5></nav>';
  myelement:=container1.ElementHandle;
  btnUAbbrechen.ParentElement:=myelement;
  btnUSpeichern.ParentElement:=myelement;

  myelement:=container2.elementhandle;
  panelUnterschreiben.parentelement:=myelement;

  myelement:=panelUnterschreiben.elementhandle;
  sigkunde.ParentElement:=myelement;
  weblabel1.ParentElement:=myelement;
  webedit1.ParentElement:=myelement;
  dsUnterschriften.Close;
  dsUnterschriften.QueryString:='$filter=Nummerkomplett eq '+QuotedStr(UMerkerLieferschein);
  dsUnterschriften.Load;
end;

procedure TLieferscheinUnterschrift.LoadDFMValues;
begin
  inherited LoadDFMValues;

  panelUnterschreiben := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  SigKunde := TSignatureCapture.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  btnUSpeichern := TButton.Create(Self);
  btnUAbbrechen := TButton.Create(Self);
  sourceUnterschriften := TDataSource.Create(Self);
  dsUnterschriften := TXDataWebDataSet.Create(Self);
  dsUnterschriftenNummerkomplett := TStringField.Create(Self);
  dsUnterschriftenDatum := TDateTimeField.Create(Self);
  dsUnterschriftenUnterschriftKunde := TBlobField.Create(Self);
  dsUnterschriftenUnterschriftKundeText := TStringField.Create(Self);
  dsUnterschriftenNachnameKunde := TStringField.Create(Self);

  panelUnterschreiben.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  SigKunde.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  btnUSpeichern.BeforeLoadDFMValues;
  btnUAbbrechen.BeforeLoadDFMValues;
  sourceUnterschriften.BeforeLoadDFMValues;
  dsUnterschriften.BeforeLoadDFMValues;
  dsUnterschriftenNummerkomplett.BeforeLoadDFMValues;
  dsUnterschriftenDatum.BeforeLoadDFMValues;
  dsUnterschriftenUnterschriftKunde.BeforeLoadDFMValues;
  dsUnterschriftenUnterschriftKundeText.BeforeLoadDFMValues;
  dsUnterschriftenNachnameKunde.BeforeLoadDFMValues;
  try
    Name := 'LieferscheinUnterschrift';
    Width := 403;
    Height := 419;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    panelUnterschreiben.SetParentComponent(Self);
    panelUnterschreiben.Name := 'panelUnterschreiben';
    panelUnterschreiben.Left := 0;
    panelUnterschreiben.Top := 133;
    panelUnterschreiben.Width := 313;
    panelUnterschreiben.Height := 270;
    panelUnterschreiben.ElementClassName := 'card m-1 border-info bg-info';
    panelUnterschreiben.Caption := 'panelUnterschreiben';
    panelUnterschreiben.Color := 12557152;
    panelUnterschreiben.ElementFont := efCSS;
    panelUnterschreiben.ElementPosition := epIgnore;
    panelUnterschreiben.ShowCaption := False;
    WebLabel1.SetParentComponent(panelUnterschreiben);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 3;
    WebLabel1.Top := 195;
    WebLabel1.Width := 105;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Name ausgeschrieben';
    WebLabel1.ElementClassName := 'text-sm';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.ElementPosition := epIgnore;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthStyle := ssPercent;
    WebLabel1.WidthPercent := 98.000000000000000000;
    WebEdit1.SetParentComponent(panelUnterschreiben);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 3;
    WebEdit1.Top := 216;
    WebEdit1.Width := 295;
    WebEdit1.Height := 21;
    WebEdit1.AutoSize := True;
    WebEdit1.ChildOrder := 4;
    WebEdit1.ElementClassName := 'form-control';
    WebEdit1.ElementFont := efCSS;
    WebEdit1.ElementPosition := epIgnore;
    WebEdit1.HeightStyle := ssAuto;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.TextHint := 'Name des Kunden';
    WebEdit1.WidthStyle := ssPercent;
    WebEdit1.WidthPercent := 98.000000000000000000;
    SigKunde.SetParentComponent(panelUnterschreiben);
    SigKunde.Name := 'SigKunde';
    SigKunde.Left := 6;
    SigKunde.Top := 11;
    SigKunde.Width := 299;
    SigKunde.Height := 186;
    SigKunde.ElementClassName := 'form-control';
    SigKunde.HeightStyle := ssAuto;
    SigKunde.WidthStyle := ssPercent;
    SigKunde.WidthPercent := 98.000000000000000000;
    SigKunde.ChildOrder := 2;
    SigKunde.ElementPosition := epIgnore;
    SigKunde.TabOrder := 1;
    SigKunde.TextPosition.Line.Color := clGray;
    SigKunde.Text := 'Unterschrift Kunde';
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 8;
    Container1.Width := 225;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 55;
    Container2.Width := 225;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    btnUSpeichern.SetParentComponent(Self);
    btnUSpeichern.Name := 'btnUSpeichern';
    btnUSpeichern.Left := 120;
    btnUSpeichern.Top := 102;
    btnUSpeichern.Width := 105;
    btnUSpeichern.Height := 25;
    btnUSpeichern.Caption := 'speichern';
    btnUSpeichern.ChildOrder := 4;
    btnUSpeichern.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnUSpeichern.ElementFont := efCSS;
    btnUSpeichern.ElementPosition := epIgnore;
    btnUSpeichern.HeightStyle := ssAuto;
    btnUSpeichern.HeightPercent := 100.000000000000000000;
    btnUSpeichern.WidthStyle := ssAuto;
    btnUSpeichern.WidthPercent := 100.000000000000000000;
    SetEvent(btnUSpeichern, Self, 'OnClick', 'btnUSpeichernClick');
    btnUAbbrechen.SetParentComponent(Self);
    btnUAbbrechen.Name := 'btnUAbbrechen';
    btnUAbbrechen.Left := 0;
    btnUAbbrechen.Top := 102;
    btnUAbbrechen.Width := 104;
    btnUAbbrechen.Height := 25;
    btnUAbbrechen.Caption := 'Abbrechen';
    btnUAbbrechen.ChildOrder := 3;
    btnUAbbrechen.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnUAbbrechen.ElementFont := efCSS;
    btnUAbbrechen.ElementPosition := epIgnore;
    btnUAbbrechen.HeightStyle := ssAuto;
    btnUAbbrechen.HeightPercent := 100.000000000000000000;
    btnUAbbrechen.WidthStyle := ssAuto;
    btnUAbbrechen.WidthPercent := 100.000000000000000000;
    SetEvent(btnUAbbrechen, Self, 'OnClick', 'btnUAbbrechenClick');
    sourceUnterschriften.SetParentComponent(Self);
    sourceUnterschriften.Name := 'sourceUnterschriften';
    sourceUnterschriften.DataSet := dsUnterschriften;
    sourceUnterschriften.Left := 32;
    sourceUnterschriften.Top := 132;
    dsUnterschriften.SetParentComponent(Self);
    dsUnterschriften.Name := 'dsUnterschriften';
    dsUnterschriften.AfterApplyUpdates := dsUnterschriftenAfterApplyUpdates;
    dsUnterschriften.AfterPost := dsUnterschriftenAfterPost;
    dsUnterschriften.EntitySetName := 'LieferscheinUnterschriften';
    dsUnterschriften.Connection := DM2.XDataWebConnection1;
    dsUnterschriften.Left := 36;
    dsUnterschriften.Top := 56;
    dsUnterschriftenNummerkomplett.SetParentComponent(dsUnterschriften);
    dsUnterschriftenNummerkomplett.Name := 'dsUnterschriftenNummerkomplett';
    dsUnterschriftenNummerkomplett.FieldName := 'Nummerkomplett';
    dsUnterschriftenNummerkomplett.Required := True;
    dsUnterschriftenNummerkomplett.Size := 10;
    dsUnterschriftenDatum.SetParentComponent(dsUnterschriften);
    dsUnterschriftenDatum.Name := 'dsUnterschriftenDatum';
    dsUnterschriftenDatum.FieldName := 'Datum';
    dsUnterschriftenUnterschriftKunde.SetParentComponent(dsUnterschriften);
    dsUnterschriftenUnterschriftKunde.Name := 'dsUnterschriftenUnterschriftKunde';
    dsUnterschriftenUnterschriftKunde.FieldName := 'UnterschriftKunde';
    dsUnterschriftenUnterschriftKundeText.SetParentComponent(dsUnterschriften);
    dsUnterschriftenUnterschriftKundeText.Name := 'dsUnterschriftenUnterschriftKundeText';
    dsUnterschriftenUnterschriftKundeText.FieldName := 'UnterschriftKundeText';
    dsUnterschriftenUnterschriftKundeText.Size := 255;
    dsUnterschriftenNachnameKunde.SetParentComponent(dsUnterschriften);
    dsUnterschriftenNachnameKunde.Name := 'dsUnterschriftenNachnameKunde';
    dsUnterschriftenNachnameKunde.FieldName := 'NachnameKunde';
    dsUnterschriftenNachnameKunde.Size := 50;
  finally
    panelUnterschreiben.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    SigKunde.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    btnUSpeichern.AfterLoadDFMValues;
    btnUAbbrechen.AfterLoadDFMValues;
    sourceUnterschriften.AfterLoadDFMValues;
    dsUnterschriften.AfterLoadDFMValues;
    dsUnterschriftenNummerkomplett.AfterLoadDFMValues;
    dsUnterschriftenDatum.AfterLoadDFMValues;
    dsUnterschriftenUnterschriftKunde.AfterLoadDFMValues;
    dsUnterschriftenUnterschriftKundeText.AfterLoadDFMValues;
    dsUnterschriftenNachnameKunde.AfterLoadDFMValues;
  end;
end;

end.
